import App from "@/components/teacher/App.vue";
import MarkdownViewTeacher from "@/components/teacher/MarkdownViewTeacher.vue"
import PlainTextView from "@/components/teacher/PlainTextView.vue";
import QuestionTextView from "@/components/teacher/QuestionTextView.vue";
import CbtBaseTabs from "@/components/teacher/CbtBaseTabs.vue";
import CbtChangeCorrectnessModal from "@/components/teacher/CbtChangeCorrectnessModal.vue";
import CbtTabs from "@/components/teacher/CbtTabs.vue";
import CbtSchedule from "@/components/teacher/CbtSchedule.vue";
import CbtReport from "@/components/teacher/CbtReport.vue";
import CbtAnswer from "@/components/teacher/CbtAnswer.vue";
import CbtAnswerResults from "@/components/teacher/CbtAnswerResults.vue";
import CbtReportResults from "@/components/teacher/CbtReportResults.vue";
import CbtExport from "@/components/teacher/CbtExport.vue";
import ChapterSectionQuestionSetList from "@/components/teacher/ChapterSectionQuestionSetList.vue";
import ClassroomLinks from "@/components/teacher/ClassroomLinks.vue";
import EntryForm from "@/components/teacher/EntryForm.vue";
import EntryStep from "@/components/teacher/EntryStep.vue";
import EntryTable from "@/components/teacher/EntryTable.vue";
import LearningStatusClass from "@/components/teacher/LearningStatusClass.vue";
import LearningStatusScatterChart from "@/components/teacher/LearningStatusScatterChart.vue";
import LearningStatusStudent from "@/components/teacher/LearningStatusStudent.vue";
import LearningStatusTable from "@/components/teacher/LearningStatusTable.vue";
import LearningStatusYear from "@/components/teacher/LearningStatusYear.vue";
import LearningStatusWorkSelector from "@/components/teacher/LearningStatusWorkSelector.vue";
import LearningProgress from "@/components/teacher/LearningProgress.vue";
import NextGrade from "@/components/teacher/NextGrade.vue";
import NextGradeByTeacher from "@/components/teacher/NextGradeByTeacher.vue";
import NextGradeByStudent from "@/components/teacher/NextGradeByStudent.vue";
import HomeworkAdd from "@/components/teacher/HomeworkAdd.vue";
import HomeworkList from "@/components/teacher/HomeworkList.vue";
import HomeworkProgress from "@/components/teacher/HomeworkProgress.vue";
import HomeworkScopeSelection from "@/components/teacher/HomeworkScopeSelection.vue";
import HomeworkEdit from "@/components/teacher/HomeworkEdit.vue";
import LineChart from "@/components/teacher/LineChart.vue";
import StudentLineChart from "@/components/student/LineChart.vue";
import NotificationList from "@/components/teacher/NotificationList.vue";
import PeriodSwitches from "@/components/teacher/PeriodSwitches.vue";
import QuestionCorrectAnswerList from "@/components/teacher/QuestionCorrectAnswerList.vue";
import QuestionCorrectAnswer from "@/components/teacher/QuestionCorrectAnswer.vue";
import ResettableSelectSingle from "@/components/teacher/ResettableSelectSingle.vue";
import SelectSingle from "@/components/teacher/SelectSingle.vue";
import StudentAnswerView from "@/components/teacher/StudentAnswerView.vue";
import StudentImportEdit from "@/components/teacher/StudentImportEdit.vue";
import SubjectTabs from "@/components/teacher/SubjectTabs.vue";
import LearningProgressSubjectTabs from "@/components/teacher/LearningProgressSubjectTabs.vue";
import WorkLicenseList from "@/components/teacher/WorkLicenseList.vue";
import BaseModal from "@/components/teacher/BaseModal.vue";
import ConfirmModal from "@/components/teacher/ConfirmModal.vue";
import ConfirmRedModal from "@/components/teacher/ConfirmRedModal.vue";
import ErrorModal from "@/components/teacher/ErrorModal.vue";
import InProgressModal from "@/components/teacher/InProgressModal.vue";
import UploadModal from "@/components/teacher/UploadModal.vue";
import InfoToast from "@/components/teacher/InfoToast.vue";
import CopyTableButton from "@/components/teacher/CopyTableButton.vue";
import { createPinia } from 'pinia'
import {createApp} from "vue";

// pinia initilization
const pinia = createPinia()

// @ts-ignore TS2584
if (document.querySelector("#app")) {
  createApp(App).mount("#app")
}

if (document.querySelector("#notification_list")) {
  // T0 先生向けトップ画面 お知らせ一覧
  createApp(NotificationList)
  .use(pinia)
  .component("markdown-view-teacher", MarkdownViewTeacher)
  .component("plain-text-view", PlainTextView)
  .mount("#notification_list")
}

if (document.querySelector("#student_import_edit")) {
  // T3-5 生徒一括変更
  const classroomUuid = document.getElementById("student_import_edit").getAttribute("data-classroom-uuid")
  createApp(StudentImportEdit,{
    classroomUuid: classroomUuid
  })
  .use(pinia)
  .component("upload-modal", UploadModal)
  .component("error-modal", ErrorModal)
  .component("in-progress-modal", InProgressModal)
  .component("modal-base", BaseModal)
  .mount("#student_import_edit")
}

if (document.querySelector("#work_license_list")) {
  // T6-1 教材ライセンス一覧
  createApp(WorkLicenseList)
  .use(pinia)
  .component("copy-table-button", CopyTableButton)
  .mount("#work_license_list")
}

if (document.querySelector("#learning_status_year")) {
  // T8-1 学習状況（学年）
  createApp(LearningStatusYear)
  .use(pinia)
  .component("subject-tabs", SubjectTabs)
  .component("period-switches", PeriodSwitches)
  .component("classroom-links", ClassroomLinks)
  .component("line-chart", LineChart)
  .component("error-modal", ErrorModal)
  .component("select-single", SelectSingle)
  .component("learning-status-work-selector", LearningStatusWorkSelector)
  .mount("#learning_status_year")
}

if (document.querySelector("#learning_status_class")) {
  // T8-2 学習状況（学級）
  createApp(LearningStatusClass)
  .use(pinia)
  .component("subject-tabs", SubjectTabs)
  .component("period-switches", PeriodSwitches)
  .component("select-single", SelectSingle)
  .component("learning-status-work-selector", LearningStatusWorkSelector)
  .component("learning-status-scatter-chart", LearningStatusScatterChart)
  .component("learning-status-table", LearningStatusTable)
  .component("error-modal", ErrorModal)
  .component("copy-table-button", CopyTableButton)
  .mount("#learning_status_class")
}

if (document.querySelector("#learning_status_student")) {
  // T8-3 学習状況（生徒）
  createApp(LearningStatusStudent)
  .use(pinia)
  .component("subject-tabs", SubjectTabs)
  .component("select-single", SelectSingle)
  .component("learning-status-work-selector", LearningStatusWorkSelector)
  .component("student-line-chart", StudentLineChart)
  .mount("#learning_status_student")
}

if (document.querySelector("#learning_progress")) {
  // T9 学習進捗表
  createApp(LearningProgress)
  .use(pinia)
  .component("select-single", SelectSingle)
  .component("error-modal", ErrorModal)
  .component("learning-progress-subject-tabs", LearningProgressSubjectTabs)
  .component("markdown-view-teacher", MarkdownViewTeacher)
  .component("plain-text-view", PlainTextView)
  .component("question-correct-answer-list", QuestionCorrectAnswerList)
  .component("question-text-view", QuestionTextView)
  .component("question-correct-answer", QuestionCorrectAnswer)
  .component("chapter-section-questionset-list", ChapterSectionQuestionSetList)
  .component("student-answer-view", StudentAnswerView)
  .mount("#learning_progress")
}

if (document.querySelector("#next_grade")) {
  // T11-1 生徒進級処理-方法選択
  const academicSessionYear = document.getElementById("next_grade").getAttribute("data-academic-session-year")
  createApp(NextGrade, {
    academicSessionYear: parseInt(academicSessionYear, 10),
  })
  .use(pinia)
  .component("error-modal", ErrorModal)
  .mount("#next_grade")
}

if (document.querySelector("#next_grade_by_teacher")) {
  // T11-2 生徒進級処理-名簿アップロード
  const el = document.getElementById("next_grade_by_teacher")
  const academicSessionYear = el.dataset.academicSessionYear
  const toAcademicYear = el.dataset.toAcademicYear
  createApp(NextGradeByTeacher, {
    academicSessionYear: parseInt(academicSessionYear, 10),
    toAcademicYear: parseInt(toAcademicYear, 10),
  })
  .use(pinia)
  .component("error-modal", ErrorModal)
  .component("modal-base", BaseModal)
  .component("confirm-modal", ConfirmModal)
  .component("upload-modal", UploadModal)
  .component("in-progress-modal", InProgressModal)
  .mount("#next_grade_by_teacher")
}

if (document.querySelector("#next_grade_by_student")) {
  // T11-3 生徒進級処理-生徒入力
  const el = document.getElementById("next_grade_by_student")
  const academicSessionYear = el.dataset.academicSessionYear
  const toAcademicYear = el.dataset.toAcademicYear
  createApp(NextGradeByStudent, {
    academicSessionYear: parseInt(academicSessionYear, 10),
    toAcademicYear: parseInt(toAcademicYear, 10),
  })
  .use(pinia)
  .component("error-modal", ErrorModal)
  .mount("#next_grade_by_student")
}


if (document.querySelector("#homework_list")) {
  // T12-1 宿題一覧
  createApp(HomeworkList)
  .use(pinia)
  .component("info-toast", InfoToast)
  .component("resettable-select-single", ResettableSelectSingle)
  .component("modal-base", BaseModal)
  .component("confirm-red-modal", ConfirmRedModal)
  .component("error-modal", ErrorModal)
  .component("copy-table-button", CopyTableButton)
  .mount("#homework_list")
}

if (document.querySelector("#homework_add")) {
  // T12-2 宿題作成
  createApp(HomeworkAdd)
  .use(pinia)
  .component("homework-scope-selection", HomeworkScopeSelection)
  .component("modal-base", BaseModal)
  .component("confirm-red-modal", ConfirmRedModal)
  .component("error-modal", ErrorModal)
  .component("markdown-view-teacher", MarkdownViewTeacher)
  .component("plain-text-view", PlainTextView)
  .component("select-single", SelectSingle)
  .component("in-progress-modal", InProgressModal)
  .mount("#homework_add")
}

if (document.querySelector("#homework_edit")) {
  // T12-3 宿題編集
  createApp(HomeworkEdit)
  .use(pinia)
  .component("homework-scope-selection", HomeworkScopeSelection)
  .component("modal-base", BaseModal)
  .component("confirm-red-modal", ConfirmRedModal)
  .component("error-modal", ErrorModal)
  .component("markdown-view-teacher", MarkdownViewTeacher)
  .component("plain-text-view", PlainTextView)
  .component("in-progress-modal", InProgressModal)
  .component("select-single", SelectSingle)
  .mount("#homework_edit")
}

if (document.querySelector("#homework_progress")) {
  // T12-5 宿題進捗一覧
  createApp(HomeworkProgress)
  .use(pinia)
  .component("resettable-select-single", ResettableSelectSingle)
  .component("error-modal", ErrorModal)
  .component("copy-table-button", CopyTableButton)
  .mount("#homework_progress")
}

if (document.querySelector("#entry_form")) {
  // T14-1 利用申込
  const dataset = document.getElementById("entry_form").dataset
  const textData = dataset.textData
  const isTeacher = dataset.isTeacher === "True"
  const schoolTypeCode = parseInt(dataset.schoolTypeCode, 10) || null
  const teacherInfo = {
    schoolName: dataset.schoolName,
    schoolCode: dataset.schoolCode,
    schoolPhone: dataset.schoolPhone,
    applicantName: dataset.applicantName,
    email: dataset.email,
    schoolTypeCode: schoolTypeCode,
  }
  createApp(EntryForm, {rawText: textData, isTeacher: isTeacher, teacherInfo: teacherInfo})
  .use(pinia)
  .component("entry-step", EntryStep)
  .component("markdown-view-teacher", MarkdownViewTeacher)
  .component("entry-table", EntryTable)
  .component("select-single", SelectSingle)
  .component("error-modal", ErrorModal)
  .mount("#entry_form")
}

if (document.querySelector("#cbt_tabs")) {
  // T15 テスト管理
  const dataset = document.getElementById("cbt_tabs").dataset
  const currentTab = dataset.tab
  createApp(CbtTabs, {currentTab: currentTab})
  .use(pinia)
  .component("cbt-base-tabs", CbtBaseTabs)
  .component("cbt-schedule", CbtSchedule)
  .component("cbt-report", CbtReport)
  .component("cbt-answer", CbtAnswer)
  .component("cbt-export", CbtExport)
  .component("info-toast", InfoToast)
  .component("error-modal", ErrorModal)
  .component("modal-base", BaseModal)
  .component("plain-text-view", PlainTextView)
  .component("resettable-select-single", ResettableSelectSingle)
  .component("markdown-view-teacher", MarkdownViewTeacher)
  .component("copy-table-button", CopyTableButton)
  .mount("#cbt_tabs")
}

if (document.querySelector("#cbt_answer_results")) {
  // T15-3 テスト管理 > 「解答確認・修正」タブ > 解答一覧
  createApp(CbtAnswerResults)
  .use(pinia)
  .component("plain-text-view", PlainTextView)
  .component("markdown-view-teacher", MarkdownViewTeacher)
  .component("student-answer-view", StudentAnswerView)
  .component("question-correct-answer", QuestionCorrectAnswer)
  .component("error-modal", ErrorModal)
  .component("modal-base", BaseModal)
  .component("cbt-change-correctness-modal", CbtChangeCorrectnessModal)
  .component("in-progress-modal", InProgressModal)
  .mount("#cbt_answer_results")
}

if (document.querySelector("#markdown_view")) {
  // マークダウンレンダリング
  const textData = document.getElementById("markdown_view").getAttribute("textData")
  createApp(MarkdownViewTeacher, {rawText: textData}).mount("#markdown_view")
}


if (document.querySelector("#cbt_report_results")) {
  // T15-2 テスト管理 > 「集計・分析」タブ > 集計結果一覧
  createApp(CbtReportResults)
  .use(pinia)
  .component("plain-text-view", PlainTextView)
  .component("markdown-view-teacher", MarkdownViewTeacher)
  .component("error-modal", ErrorModal)
  .component("copy-table-button", CopyTableButton)
  .mount("#cbt_report_results")
}